
import { NodeAPI, FlaskAPI } from "../api";

export const isAnswerCorrect = async (userAnswer, correctAnswer) => {
  try {
    const response = await FlaskAPI.post("quiz/check-answer", {
      user_answer: userAnswer,
      correct_answer: correctAnswer,
    });

    return response.data.is_correct;
  } catch (error) {
    console.error("❌ Error in isAnswerCorrect:", error.response?.data || error.message);
    throw new Error("AI check failed");
  }
};
